import { opts } from "../opts.js"
import { searchBox } from '../../../../../dist/vendor/instantsearch.js/es/widgets/index.js';

export const config = {
	...opts.searchBox,
	templates: {
		reset({ cssClasses }, { html }) {
			return html`<span></span>`;
		},
		submit({ cssClasses }, { html }) {
		  return html`
				<svg class="svg svg--svg-assets-svg-icon-search" role="presentation" focusable="false" height="23" width="23">
					<use xlink:href="#svg-assets-svg-icon-search"></use>
				</svg>
			`
		},
	},
}
export const widget = searchBox;
